<script setup lang="ts">
    import { gsap } from 'gsap';
    const { cartItems, subtotal, shippingTotal } = useCart();
    const { shippingMethods, getShippingMethods } = useCheckout();

    const { t } = useI18n();

    const shippingCap = ref(0);
    const sum = ref();
    const fraction = ref();
    const progress = ref();

    const progressBar = ref();
    const progressText = ref();
    const maxProgressBar = ref();

    const hasItems = computed(() => cartItems.value.length > 0);

    const animateProgress = () => {
        const loadingAnimTl = gsap.timeline({
            repeat: 0
        });
        loadingAnimTl.to(progressBar.value, {
            width: `${progress.value}%`,
            duration: 1.6,
            stagger: 0.015,
            ease: 'power1.inOut'
        });
        if (progress.value < 50) {
            loadingAnimTl.to(progressBar.value, {
                duration: 0.2,
                backgroundColor: 'rgb(220, 22, 22)'
            });
            loadingAnimTl.to(maxProgressBar.value, {
                duration: 0.2,
                borderColor: 'rgb(220, 22, 22)'
            });
        } else if (progress.value > 50 && progress.value < 100) {
            loadingAnimTl.to(progressBar.value, {
                duration: 0.2,
                backgroundColor: 'rgb(255, 188, 65)'
            });
            loadingAnimTl.to(maxProgressBar.value, {
                duration: 0.2,
                borderColor: 'rgb(255, 188, 65)'
            });
        } else {
            loadingAnimTl.to(progressBar.value, {
                duration: 0.2,
                backgroundColor: 'rgb(175, 230, 175)'
            });
            loadingAnimTl.to(maxProgressBar.value, {
                duration: 0.2,
                borderColor: 'rgb(175, 230, 175)'
            });
        }
        loadingAnimTl.to(progressText.value, {
            duration: 0.3,
            opacity: 1
        });

        loadingAnimTl.to(maxProgressBar.value, {
            duration: 1,
            scaleY: 1.3,
            scaleX: 1.03,
            yoyo: true,
            ease: 'elastic.inOut(1,1)'
        });
        loadingAnimTl.to(maxProgressBar.value, {
            duration: 1,
            scaleY: 1,
            scaleX: 1,
            yoyo: true,
            ease: 'elastic.out(1,0.15)'
        });
    };
    onMounted(() => {
        Promise.any([getShippingMethods()]).finally(() => {
            if (!shippingMethods.value[0]?.prices?.[0]?.quantityEnd) {
                log.warn('[FreeShipping.vue] Missing `shippingMethods.value[0].prices[0].quantityEnd`');
                return;
            }
            shippingCap.value = shippingMethods.value[0].prices[0].quantityEnd;
            sum.value = (shippingCap.value - subtotal.value).toFixed(2);
            fraction.value = (sum.value / shippingCap.value) * 100;

            if (shippingTotal.value == 0) {
                progress.value = 100;
                fraction.value = 100;
            } else {
                progress.value = 100 - fraction.value;
            }

            animateProgress();
        });
    });
</script>

<template>
    <div
        v-if="hasItems"
        class="free-shipping-container"
    >
        <p
            ref="progressText"
            class="progress-text"
        >
            {{ shippingTotal !== 0 ? t('cart.progressText', { sum: sum?.replace('.', ',') }) : t('cart.freeShipping') }}
        </p>
        <div
            ref="maxProgressBar"
            class="progress-bar"
        >
            <div
                ref="progressBar"
                class="progress"
                :class="{ '--is-max': shippingTotal == 0 }"
            ></div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/cart/free-shipping.scss';
</style>
